export default __webpack_public_path__ + "static/media/social.7b765b58.png";